export const RMA_MANAGER_USER = 'RMA Manager (User)';
export const RMA_MANAGER_MANAGER = 'RMA Manager (Manager)';
export const RMA_MANAGER_ALLOW_FEES = 'RMA Manager (Allow Fees)';
export const QUOTE = 'Quote';
export const ORDER_MANAGER = 'Order Manager';
export const CHECKOUT = 'Checkout';
